import React from 'react';
import MuiGrid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Link from 'next/link';
import FacebookIcon from '../../shared/icons/Facebook';
import YoutubeIcon from '../../shared/icons/Youtube';
import TwitterIcon from '../../shared/icons/Twitter';
import useForceUpdate from '../../utils/useForceUpdate';

const useStyles = makeStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(2, 1.5),
  },
  divider: {
    margin: theme.spacing(0, 1),
  },
  signAgainButton: {
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.grey[500],
    },
  },
}));

const Footer = () => {
  const forceUpdate = useForceUpdate();
  const alreadySignedUp =
    global.document && document.cookie.indexOf('MCPopupSubscribed') > -1;
  const handleDeleteCookie = () => {
    document.cookie =
      'MCPopupSubscribed=; expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/;';
    forceUpdate();
  };
  const handleNewsletterSignup = () => {
    if (window.showMailingPopUp) window.showMailingPopUp();
  };
  const classes = useStyles();
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : '/depi/';
  return (
    <React.Fragment>
      <footer className={classes.root}>
        <MuiGrid container spacing={3}>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center" height="100%">
              <Link href={`${linkContext}kontakt`} passHref>
                <Typography component="a" variant="body1">
                  Kontakt
                </Typography>
              </Link>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
              />

              <Link href={`${linkContext}impressum`} passHref>
                <Typography component="a" variant="body1">
                  Impressum
                </Typography>
              </Link>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
              />

              <Link href={`${linkContext}datenschutz`} passHref>
                <Typography component="a" variant="body1">
                  Datenschutz
                </Typography>
              </Link>
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Link href={`${linkContext}newsletter`} passHref>
                <Button variant="outlined" disabled={alreadySignedUp}>
                  Newsletter abonnieren
                </Button>
              </Link>
            </Box>
          </MuiGrid>
          {alreadySignedUp && (
            <MuiGrid item xs={12}>
              <Box display="flex" justifyContent="center">
                <Typography variant="body2" color="textSecondary">
                  Sie haben sich bereits für den Newsletter angemeldet.{' '}
                  <span
                    className={classes.signAgainButton}
                    onMouseDown={handleDeleteCookie}
                  >
                    Erneut anmelden?
                  </span>
                </Typography>
              </Box>
            </MuiGrid>
          )}
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Typography variant="body2" color="textSecondary">
                Folgen Sie uns auf
              </Typography>
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/DeutschesPelletinstitut/"
              >
                <FacebookIcon color="primary" />
              </a>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
                light
              />

              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/DEPI_Pellets"
              >
                <TwitterIcon color="primary" />
              </a>
              <Divider
                orientation="vertical"
                flexItem
                className={classes.divider}
                light
              />

              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/watch?v=kNh0Z8uq8_w"
              >
                <YoutubeIcon color="primary" />
              </a>
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Typography variant="caption" color="textSecondary">
                Copyright © 2008-{new Date().getFullYear()} DEPI. Alle Rechte
                vorbehalten.
              </Typography>
            </Box>
          </MuiGrid>
        </MuiGrid>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
